<ng-container *ngIf="!otpConfirmed; else confirmedMessage">
  <div class="d-flex flex-column justify-content-center align-items-center text-center px-3">
    <div class="mb-3">
      <div class="spinner-border text-primary" style="width: 64px; height: 64px;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <p>
      {{ 'Please confirm your identity by entering the OTP sent to' | translate }}
      <strong>{{ phoneNumber != null || phoneNumber != undefined ? phoneNumber : 'users phone number' | translate
        }}</strong>.
    </p>

    <p *ngIf="countdown>0">
      {{ 'The code will expire in' | translate }}
      <strong>{{ countdown }}s</strong>.
    </p>

    <button *ngIf="countdown <= 0" style="text-decoration: none; height: 30px;" (click)="resendCode()"
      class="btn btn-link p-0 mb-2 d-flex align-items-center gap-1 w-auto">
      {{ 'Resend code' | translate }}
      <span class="material-symbols-rounded">refresh</span>
    </button>

    <div style="height: 83px;">
      <ng-otp-input *ngIf="showOtpInput" #otpInput
        [config]="{length: 5, inputClass: 'otp-input-custom mb-4', allowNumbersOnly: true}" [inputMode]="'numeric'"
        (onInputChange)="onOtpChange($event)">
      </ng-otp-input>
    </div>

  </div>
</ng-container>

<ng-template #confirmedMessage>
  <div class="d-flex flex-column justify-content-center align-items-center text-center px-3">
    <i class="bi bi-check-circle-fill text-success mb-3" style="font-size: 3rem;"></i>
    <ng-content></ng-content>

  </div>
</ng-template>